module.exports = __webpack_public_path__ + "static/ic-internal-error-107.c555423d.svg";